import { render, staticRenderFns } from "./UploadPhotosModal.vue?vue&type=template&id=10f6bfe4&scoped=true&"
import script from "./UploadPhotosModal.vue?vue&type=script&lang=js&"
export * from "./UploadPhotosModal.vue?vue&type=script&lang=js&"
import style0 from "./UploadPhotosModal.vue?vue&type=style&index=0&id=10f6bfe4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f6bfe4",
  null
  
)

export default component.exports